import React, { FC } from 'react'

import { Router } from './router'
import { ThemeProvider } from './theme'

export const App: FC = () => {
  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  )
}
